var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutFill0Wgh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght400_GRAD0_opsz24",
    d: "M133.333-825a1.6,1.6,0,0,0,1.177-.49,1.6,1.6,0,0,0,.49-1.177v-11.667a1.605,1.605,0,0,0-.49-1.177,1.6,1.6,0,0,0-1.177-.49H127.5v1.667h5.833v11.667H127.5V-825Zm-9.167-3.333,1.146-1.208-2.125-2.125H130v-1.667h-6.812l2.125-2.125-1.146-1.208L120-832.5Z",
    transform: "translate(-120 840)",
    fill: "#d0d0d0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutFill0Wgh);
export default __webpack_public_path__ + "static/media/logout_FILL0_wgh.1dfb7c6dcdfc7decb0614ac558c7a8f2.svg";
export { ForwardRef as ReactComponent };